<template>
  <v-dialog
    :value="value"
    max-width="820"
    scrollable
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="dry-run-title">
        <v-icon color="warning" class="mr-2">{{
          icons.mdiAlertOutline
        }}</v-icon>
        No collection was booked with The Courier Guy
      </v-card-title>
      <v-card-subtitle class="pt-2">
        This server previews Courier Guy requests instead of sending them. Below
        is exactly what would have been sent on production.
      </v-card-subtitle>
      <v-card-text>
        <pre class="dry-run-payload">{{ requests }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="copyRequests">
          {{ copied ? 'Copied' : 'Copy' }}
        </v-btn>
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mdiAlertOutline } from '@mdi/js';

  export default {
    name: 'DryRunRequestsDialog',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      requests: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        icons: { mdiAlertOutline },
        copied: false,
      };
    },
    watch: {
      value(open) {
        if (open) {
          this.copied = false;
        }
      },
    },
    methods: {
      close() {
        this.$emit('input', false);
      },
      async copyRequests() {
        try {
          await navigator.clipboard.writeText(this.requests);
          this.copied = true;
        } catch (error) {
          console.warn('Could not copy the request preview:', error);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .dry-run-title {
    word-break: normal;
    line-height: 1.3;
  }

  .dry-run-payload {
    background: #f5f5f5;
    border-radius: 6px;
    padding: 12px;
    font-family: monospace;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre;
    overflow-x: auto;
  }
</style>
